module.exports = __webpack_public_path__ + "static/img/wyeth.6da44dbb.jpg";